// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"8b79a6bb","513":"2cc2def2","703":"b829459e"}[chunkId] + ".chunk.js";
};